import { useLazyQuery } from '@apollo/client';
import { useDispatch } from 'react-redux';
import { MemberBigNInput } from '@pass-frontend/data-access/common/edge';
import {
  eligibilityLookupSlice,
  MEMBER_CHECK_BY_BIG_N,
} from '@pass-frontend/features/facility-checkin/data-access';

export const useMemberEligibility = () => {
  const [fetchMemberByEligiblity, { loading, data, error }] = useLazyQuery<
    any,
    {
      input: MemberBigNInput;
    }
  >(MEMBER_CHECK_BY_BIG_N, {
    fetchPolicy: 'no-cache',
  });

  const dispatch = useDispatch();
  if (data?.memberCheckForBigN) {
    dispatch(
      eligibilityLookupSlice.actions.setMemberDetails(data?.memberCheckForBigN),
    );
  }

  return {
    loading,
    error,
    data,
    fetchMemberByEligiblity: (input: MemberBigNInput) => {
      fetchMemberByEligiblity({
        variables: { input },
      });
    },
    memberCheckForBigN: data?.memberCheckForBigN,
  };
};
